import React, { useState, useEffect, useRef } from "react";
import {
    Box,
    Grid,
    Typography,
    Card,
    CardContent,
    IconButton,
    Button,
    Menu,
    MenuItem,
    TextField,
    Pagination,
    InputAdornment,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Alert
} from "@mui/material";
import { Download, Visibility, FilterAlt } from "@mui/icons-material";
import { CiSearch } from "react-icons/ci";
import { useSelector, useDispatch } from "react-redux";
import Loading from "../../components/UI/Loading/Loading";
import { useNavigate } from "react-router-dom";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { useLanguage } from '../../context/LanguageContext/LanguageContext';
import { fetchContracts, filterContracts } from "../../redux/slices/myAccount/contractsSlice";
import NotFound from "../../components/NotFoundService/NotFoundService";
import { FaFilePdf, FaFileWord, FaFileAlt } from 'react-icons/fa';
import CustomPagination from "../../components/MyAccount/Pagination/Pagination";
import pdf from "./../../assets/images/service/pdf.png";
import word from "./../../assets/images/service/docs.png";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';
import { SingleInputDateRangeField } from '@mui/x-date-pickers-pro/SingleInputDateRangeField';
import { MdErrorOutline } from "react-icons/md";

import DatePicker from "react-datepicker"; // Assuming you're using react-datepicker
import "react-datepicker/dist/react-datepicker.css";
const Contracts = () => {
    const [baseURL, setBaseURL] = useState('');
    useEffect(() => {
        // Fetch the config.json to get the baseURL
        const fetchConfig = async () => {
            try {
                const response = await fetch('/config.json');
                const config = await response.json();
                setBaseURL(config.baseURL);
            } catch (error) {
                console.error('Error fetching config.json:', error);
            }
        };

        fetchConfig();
    }, []);
    const [anchorEl, setAnchorEl] = useState(null); // for dropdown
    const [selectedPeriod, setSelectedPeriod] = useState("");
    const [selectedDateRange, setSelectedDateRange] = useState([null, null]); // Store selected date range (start, end)
    const datePickerRef = useRef(null);

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [searchValue, setSearchValue] = useState("");
    const [filterOpen, setFilterOpen] = useState(false);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const { isLoggedIn, user, token } = useSelector(state => state.login);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isPeriodSelected, setIsPeriodSelected] = useState(false);

    const [isDatePickerVisible, setDatePickerVisible] = useState(false); // Manage visibility of the date picker
    const { contracts, filteredContracts, loading, error } = useSelector((state) => state.contracts);
    const [selectedContract, setSelectedContract] = useState(null);
    const [downloadError, setDownloadError] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState(null);
    const dropdownRef = useRef(null);
    const { translations, direction, language } = useLanguage();
    const t = translations;
    // Handle date selection for custom period inside the dropdown
    const handleCustomPeriodSelect = () => {
        setSelectedPeriod('Custom Period');
    };

    const handleDateChange = (dates, event) => {
        const [startDate, endDate] = dates;

        // Prevent form submission (if inside a form)
        if (event && event.preventDefault) {
            event.preventDefault();
        }

        // Update the state with the selected dates
        setSelectedDateRange([startDate, endDate]);
        // Only update start and end date if both are selected
        if (startDate && endDate) {
            // Set both dates to the beginning of the day to avoid time zone shifts
            const startDateWithoutTime = new Date(startDate.setHours(14, 0, 0, 0)); // Start at 00:00
            const endDateWithoutTime = new Date(endDate.setHours(23, 59, 59, 999)); // End at 23:59:59


            setStartDate(startDateWithoutTime.toISOString());
            setEndDate(endDateWithoutTime.toISOString());
        }
    };


    const handlePeriodSelect = (period) => {
        setSelectedPeriod(period);
        setIsPeriodSelected(true);
        let calculatedStartDate = null;
        let calculatedEndDate = new Date(); // Default to current date

        switch (period) {
            case 'Last 7 Days':
                calculatedStartDate = new Date();
                calculatedStartDate.setDate(calculatedEndDate.getDate() - 7);
                break;
            case 'Last 30 Days':
                calculatedStartDate = new Date();
                calculatedStartDate.setDate(calculatedEndDate.getDate() - 30);
                break;
            case 'Last 90 Days':
                calculatedStartDate = new Date();
                calculatedStartDate.setDate(calculatedEndDate.getDate() - 90);
                break;
            case 'This Month':
                calculatedStartDate = new Date(calculatedEndDate.getFullYear(), calculatedEndDate.getMonth(), 1);
                break;
            case 'Last Month':
                calculatedEndDate = new Date(calculatedEndDate.getFullYear(), calculatedEndDate.getMonth(), 0);
                calculatedStartDate = new Date(calculatedEndDate.getFullYear(), calculatedEndDate.getMonth() - 1, 1);
                break;
            case 'Custom Period':
                // Show date pickers for custom period
                break;
            default:
                break;
        }

        if (calculatedStartDate && calculatedEndDate) {
            const formattedStartDate = calculatedStartDate.toISOString();
            const formattedEndDate = calculatedEndDate.toISOString();

            setStartDate(formattedStartDate);
            setEndDate(formattedEndDate);
        }

        handleMenuClose();
    };

    const handleFilterToggle = (event) => {
        event.preventDefault(); // Prevent default behavior that may be causing the reload
        setAnchorEl(event.currentTarget);
    };
    // Handle closing the dropdown
    const handleMenuClose = (event) => {
        if (datePickerRef.current && datePickerRef.current.contains(event.target)) {
            // Prevent the menu from closing if the click is inside the DatePicker
            return;
        }
        setAnchorEl(null); // Close dropdown
    };


    useEffect(() => {
        if (user.id) {
            dispatch(fetchContracts({ userId: user.id, startDate, endDate, language, token }));
        }
    }, [dispatch, user.id, language, startDate, endDate]);
    useEffect(() => {
        // Trigger filtering whenever the search value or date range changes
        dispatch(filterContracts({ searchValue, startDate, endDate }));
    }, [searchValue, startDate, endDate, dispatch]);

    // Close menu when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownOpen(null);  // Close dropdown when clicked outside
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    const getFileIcon = (filePath) => {
        const fileExtension = filePath?.split('.').pop().toLowerCase();

        switch (fileExtension) {
            case 'pdf':
                return <img src={pdf} alt="PDF Icon" width={84} height={84} loading="lazy" />;
            case 'doc':
            case 'docx':
                return <img src={word} alt="Word Icon" width={84} height={84} loading="lazy" />;
            default:
                return <img src={`${baseURL}/Upload${filePath}`} alt=" File Icon" width={84} height={84} loading="lazy" style={{ borderRadius: "10px" }} />;
        }
    };


    const handleSearchChange = (event) => {
        setSearchValue(event.target.value);
    };

    const filteredAndPaginatedContracts = filteredContracts.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    const toggleDropdown = (id) => {
        setDropdownOpen((prev) => (prev === id ? null : id));
    };
    const handleDownload = (contract) => {
        if (contract?.filePath) {
            const filePath = `${baseURL}/Upload${contract.filePath}`;

            // Fetch the image blob
            fetch(filePath)
                .then(response => response.blob()) // Get the image blob
                .then(blob => {
                    const link = document.createElement("a");
                    const objectURL = URL.createObjectURL(blob); // Create an object URL for the blob

                    link.href = objectURL;
                    link.download = contract.fileName || "contract"; // Use the file name or default
                    link.target = "_blank"; // Open in a new tab (optional)

                    // Trigger the download
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                    // Clean up the object URL after the download
                    URL.revokeObjectURL(objectURL);
                })
                .catch(error => {
                    setDownloadError(true);
                    console.error("Download error:", error);
                });
        } else {
            alert("No file available for download.");
        }
        setDropdownOpen(null);
    };


    const handleViewDetails = (contract) => {
        if (contract) {
            navigate(`/my-account/contracts/${contract.contractId}`, { state: { contract } });
        }
        setDropdownOpen(null);
    };

    if (!isLoggedIn) {
        navigate('/signin');
        return null;
    }

    if (loading) return <Loading />;
    // if (!filteredAndPaginatedContracts || filteredAndPaginatedContracts.length === 0) {
    //     return <NotFound message={t.noContractDataAvailable} />;
    // }
    return (
        <Box sx={{ p: 3, backgroundColor: "#f9f9f9", minHeight: "100vh" }}>
            {/* Search and Filter Section */}
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
                {/* Search Input */}
                <TextField
                    variant="outlined"
                    placeholder={t.searchcontracts}
                    InputProps={{
                        disableUnderline: true,
                        endAdornment: (
                            <InputAdornment position="end">
                                <CiSearch style={{ fontSize: '28px', color: '#A4A4A4' }} />
                            </InputAdornment>
                        ),
                    }}
                    sx={{
                        width: '300px',
                        height: '56px',
                        backgroundColor: '#FDFDFD',
                        boxShadow: '0px 11px 23px 0px #00000005',
                        borderRadius: '12px',
                        '& .MuiOutlinedInput-root': {
                            border: 'none',
                        },
                        '& .MuiOutlinedInput-notchedOutline': {
                            border: 'none',
                        },
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                            border: 'none',
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            border: 'none',
                        },
                        '& .MuiInputBase-input::placeholder': {
                            fontSize: '16px',
                        },
                    }}
                    onChange={handleSearchChange}
                />

                {/* Filter Period Button with Dropdown */}
                <Button
                    variant="contained"
                    onClick={handleFilterToggle}
                    sx={{
                        backgroundColor: "var(--primary-color)",
                        textTransform: "none",
                        fontSize: { md: "16px", xs: "13px" },
                        fontWeight: 600,
                        padding: { md: "10px 20px", xs: "12px" },
                        "&:hover": { backgroundColor: "var(--primary-color-dark)" },
                        borderRadius: "12px",
                        display: "flex",
                        alignItems: "center",
                    }}
                >
                    <FilterAlt sx={{ mr: 1 }} /> {t.filterPeriod}
                </Button>
            </Box>
            {/* Dropdown Menu */}
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
            >
                <MenuItem onClick={() => handlePeriodSelect('Last 7 Days')} sx={{ justifyContent: direction === "ltr" ? "flex-end" : "flex-start" }}>{t.Last7Days}</MenuItem>
                <MenuItem onClick={() => handlePeriodSelect('Last 30 Days')} sx={{ justifyContent: direction === "ltr" ? "flex-end" : "flex-start" }}>{t.Last30Days}</MenuItem>
                <MenuItem onClick={() => handlePeriodSelect('Last 90 Days')} sx={{ justifyContent: direction === "ltr" ? "flex-end" : "flex-start" }}>{t.last90Days}</MenuItem>
                <MenuItem onClick={() => handlePeriodSelect('This Month')} sx={{ justifyContent: direction === "ltr" ? "flex-end" : "flex-start" }}>{t.ThisMonth}</MenuItem>
                <MenuItem onClick={() => handlePeriodSelect('Last Month')} sx={{ justifyContent: direction === "ltr" ? "flex-end" : "flex-start" }}>{t.LastMonth}</MenuItem>
                <MenuItem onClick={handleCustomPeriodSelect} sx={{ justifyContent: direction === "ltr" ? "flex-end" : "flex-start" }}>{t.customPeriod}</MenuItem>
                {selectedPeriod === 'Custom Period' && (
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Box sx={{ display: 'flex', gap: 2 }}>
                            <DatePicker
                                selected={selectedDateRange[0]}  // Start date
                                onChange={handleDateChange}  // Handler for date change
                                startDate={selectedDateRange[0]}  // Start date
                                endDate={selectedDateRange[1]}  // End date
                                selectsRange
                                inline
                            />
                        </Box>
                    </LocalizationProvider>
                )}
            </Menu>


            {filteredAndPaginatedContracts.length === 0 && (
                <Box sx={{ textAlign: 'center', padding: '20px', color: "gray", borderRadius: '8px', marginBottom: '20px' }}>
                    <Typography variant="h6">{t.noContractDataAvailable}</Typography>
                </Box>
            )}

            {/* Contracts List */}

            <Grid container spacing={3}>
                {downloadError && (
                    <Alert
                        severity="error"
                        onClose={() => setDownloadError(false)}
                        sx={{ position: "absolute", top: "10px", left: "50%", transform: "translateX(-50%)", zIndex: 10 }}
                    >
                        Error downloading the file. Please try again.
                    </Alert>
                )}
                {filteredAndPaginatedContracts.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((contract) => (
                    <Grid item xs={12} sm={6} md={5} lg={4} xl={3} key={contract.contractId}>
                        <Card
                            sx={{
                                borderRadius: "12px",
                                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                                padding: "8px",
                                backgroundColor: "#FFFFFF",
                                position: "relative",
                                height: "330px",
                            }}
                        >
                            <CardContent>
                                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2, position: "relative" }}>
                                    <Box sx={{ display: "flex", alignItems: "center", }}>

                                        <Box sx={{ ml: direction === "ltr" ? "" : 2, mr: direction === "rtl" ? "" : 2 }}>
                                            {contract?.filePath ? (
                                                getFileIcon(contract?.filePath) // Show the icon based on file extension
                                            ) : (
                                                <FaFileAlt size={84} /> // Show a default icon if no file path
                                            )}
                                        </Box>
                                        {/* Contract Name and Price */}
                                        <Box>
                                            <Typography variant="h6" sx={{
                                                wordBreak: "break-word", // Ensures that long words will break and wrap
                                                whiteSpace: "normal", fontWeight: 600, fontSize: "14px", mb: "4px", mt: "4px",
                                            }}>
                                                {contract.contractNameLocalized || "NULL"}
                                            </Typography>
                                            <Typography sx={{ fontSize: "14px", fontWeight: "bold", }}>
                                                ${contract?.totalAmount || "0.00"}
                                            </Typography>
                                        </Box>
                                        {/* Contract Icon */}

                                    </Box>
                                    {/* Menu Button at the Top Right */}
                                    <Box
                                        ref={dropdownRef}
                                        sx={{
                                            position: "absolute",
                                            top: "-5px",
                                            right: direction === "ltr" ? "-5px" : "",
                                            left: direction === "rtl" ? "-5px" : "",
                                        }}
                                    >
                                        <IconButton onClick={() => toggleDropdown(contract.contractId)}>
                                            <MoreHorizIcon sx={{ color: "#6F6F6F" }} />
                                        </IconButton>

                                        {/* Custom Dropdown */}
                                        {dropdownOpen === contract.contractId && (
                                            <Box
                                                ref={dropdownRef}
                                                sx={{
                                                    position: "absolute",
                                                    top: "40px",
                                                    right: direction === "ltr" ? "0" : "",
                                                    left: direction === "rtl" ? "0" : "",
                                                    zIndex: 10,
                                                    width: "200px",
                                                    backgroundColor: "#FFFFFF",
                                                    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                                                    borderRadius: "8px",
                                                    overflow: "hidden",
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        padding: "12px 16px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        cursor: "pointer",
                                                        "&:hover": { backgroundColor: "#f0f0f0" },
                                                    }}
                                                    onClick={() => handleDownload(contract)}

                                                >
                                                    <Download sx={{ color: "#209F84", fontSize: "15px", marginRight: "8px" }} />
                                                    {t.download}
                                                </Box>
                                                <Box
                                                    sx={{
                                                        padding: "12px 16px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        cursor: "pointer",
                                                        "&:hover": { backgroundColor: "#f0f0f0" },
                                                    }}
                                                    onClick={() => handleViewDetails(contract)}
                                                >
                                                    <MdErrorOutline style={{ color: "#6F6F6F", fontSize: "15px", marginRight: "8px" }} />
                                                    {t.viewDetails}
                                                </Box>
                                            </Box>
                                        )}
                                    </Box>

                                </Box>


                                <Typography sx={{ color: "#232321", fontSize: "14px", mb: "4px", fontWeight: 600 }}>
                                    {t.description2}
                                </Typography>
                                {/* Description */}
                                <Typography variant="body2" color="text.secondary" sx={{
                                    mb: 2,
                                    fontSize: "12px",
                                    wordBreak: 'break-word',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                }}>
                                    {contract?.contractDescription || "NULL"}
                                </Typography>

                                {/* Dates Section with Left-Right Alignment and Underline */}
                                <Box
                                    sx={{
                                        // backgroundColor: "#F8F8F8",
                                        padding: "12px",
                                        borderRadius: "8px",
                                        border: "0.75px solid #2323214D"
                                    }}
                                >
                                    {/* Start Date Row */}
                                    <Box sx={{ display: "flex", justifyContent: "space-between", borderBottom: "1px solid #E0E0E0", paddingBottom: "8px", marginBottom: "8px" }}>
                                        <Typography variant="caption" sx={{ color: "#6F6F6F", fontSize: "12px" }}>
                                            {t.startDate}
                                        </Typography>
                                        <Typography sx={{ fontWeight: 600, fontSize: "12px" }}>
                                            {new Date(contract.startDate).toLocaleDateString() || "null"}
                                        </Typography>
                                    </Box>

                                    {/* End Date Row */}
                                    <Box sx={{ display: "flex", justifyContent: "space-between", borderBottom: "1px solid #E0E0E0", paddingBottom: "8px", marginBottom: "8px" }}>
                                        <Typography variant="caption" sx={{ color: "#6F6F6F", fontSize: "12px" }}>
                                            {t.endDate}
                                        </Typography>
                                        <Typography sx={{ fontWeight: 600, fontSize: "12px" }}>
                                            {new Date(contract.endDate).toLocaleDateString() || "null"}
                                        </Typography>
                                    </Box>

                                    {/* Unit Name Row */}
                                    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                                        <Typography variant="caption" sx={{ color: "#6F6F6F", fontSize: "12px" }}>
                                            {t.unitName}
                                        </Typography>
                                        <Typography sx={{ fontWeight: 600, fontSize: "12px" }}>
                                            {contract?.equipmentName || "NULL"}
                                        </Typography>
                                    </Box>
                                </Box>

                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>


            <CustomPagination
                page={page}
                setPage={setPage}
                totalPages={Math.ceil(filteredAndPaginatedContracts.length / 6)}
                totalData={filteredAndPaginatedContracts.length}
                itemsPerPage={rowsPerPage}
            />



        </Box>
    );
};

export default Contracts;
